import type { FaireProductEntity } from "../../entity_types/product";

export const p_bpchyjzj4w: FaireProductEntity = {
  token: "p_bpchyjzj4w",
  type: "product",
  name: "Wish Liquid hand sanitizer spray 1.2oz with bag",
  brandToken: "b_97nhawnvjk",
  brandName: "Deluxe Import Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/d9b360c3199bf29e45a1d5031be7b31f476463a4da8b153e8bd0183a60d432f9.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.75,
  description:
    "Deluxe Import Trading presents the Wish Liquid hand sanitizer spray. This 1.2oz sanitizer comes with a convenient bag, making it perfect for on-the-go use. As a family-owned business for 35 years, we're committed to providing high-quality, low-cost goods. This sanitizer upholds our reputation for quality products, combining effectiveness with convenience. It's perfect for use in a variety of settings, from independent retailers to department stores and gas stations.",
  tags: [],
  msrpDollars: 3.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:31.657Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
